<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="赛区" prop="saiqu">
              <el-input
                  type="text"
                  disabled
                  v-model="formData.saiqu_name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位" prop="danwei">
              <el-input
                  type="text"
                  disabled
                  v-model="formData.danwei"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="队伍名称" prop="mingcheng">
              <el-input
                  type="text"
                  placeholder="请输入队伍名称"
                  v-model="formData.mingcheng"
              ></el-input>
            </el-form-item>
            <div class="form-label-desc" v-show="formData.mingcheng">您的队伍全称是
            <span style="font-weight: bold; font-size: 18px; color: #ff9535">{{formData.danwei}} {{formData.mingcheng}} 啦啦队</span></div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="队伍照片" prop="grade">
              <PicUploader :fileList="formData.heying" :limit="1"></PicUploader>
              <div class="form-label-desc">上传一张队伍照片(横版)</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="领队姓名" prop="ldname">
              <el-input
                  type="text"
                  placeholder="请输入领队姓名"
                  v-model="formData.ldname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="ldcardtype">
              <el-radio-group v-model="formData.ldcardtype">
                <el-radio :label="1">身份证</el-radio>
                <el-radio :label="2">护照</el-radio>
                <el-radio :label="3">其他身份证明</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证件号码" prop="ldnum">
            <el-input
                type="text"
                placeholder="请输入证件号码"
                v-model="formData.ldnum"
            ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="领队性别" prop="ldsex">
              <el-radio-group v-model="formData.ldsex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="领队手机" prop="phone">
            <el-input
                type="text"
                placeholder="请输入领队手机"
                v-model="formData.phone"
            ></el-input>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="lxname">
              <el-input
                  type="text"
                  placeholder="请输入联系人"
                  v-model="formData.lxname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人手机" prop="lxphone">
              <el-input
                  type="text"
                  placeholder="请输入联系人手机"
                  v-model="formData.lxphone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>教练/裁判信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="随队裁判">
              <div style="cursor: pointer" @click="showCaipanPicker = true">请选择裁判 <i class="el-icon-arrow-right"></i></div>
              <div v-show="formData.caipan.length>0">
                <div class="memberLi" v-for="(caipan ,index) in formData.caipan" :key=index>
                  裁判员
                  <el-tag
                      :key="index"
                      round
                      closable
                      type="primary"
                      @close="formData.caipan.splice(index,1)"
                  > {{caipan.name}} {{caipan.num}}
                  </el-tag>
                </div>
              </div>
              <div class="form-label-desc">如无法全程参与执裁，则无需填写随队裁判</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教练员">
              <div style="cursor: pointer" @click="showJiaolianPicker = true">请选择教练员 <i class="el-icon-arrow-right"></i></div>
              <div v-show="formData.jiaolian.length>0">
                <div class="memberLi" v-for="(caipan ,index) in formData.jiaolian" :key=index>
                  第{{(['一','二','三','四','五'])[index]}}教练员
                  <el-tag
                      :key="index"
                      round
                      closable
                      type="primary"
                      @close="formData.jiaolian.splice(index,1)"
                  > {{caipan.name}} {{caipan.num}}
                  </el-tag>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">下一步
            </el-button>
<!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>


      <CaipanPicker
          :show="showCaipanPicker"
          :limit="1"
          :danweiId="formData.danwei_id"
          @onChange="onCaipanChange"
          @onClose="showCaipanPicker=false"
          :defaultValue="formData.caipan"
          @onConfirm="onCaipanConfirm"
      ></CaipanPicker>

      <JiaolianPicker
          :show="showJiaolianPicker"
          :limit="5"
          :danweiId="formData.danwei_id"
          @onChange="onJiaolianChange"
          @onClose="showJiaolianPicker=false"
          :defaultValue="formData.jiaolian"
          @onConfirm="onJiaolianConfirm"
      ></JiaolianPicker>

      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep1',
  components: {
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      showCaipanPicker: false,
      showJiaolianPicker: false,
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他'],
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        saiqu_name: '',
        numTypeName: '身份证',
        danwei: '',
        ldcardtype: 1,
        ldsex: 1,
        heying: [],
//                            [{name:"选择商户.png",
//                        save_name:"h5/2020-05-11/1589187988243621.png",
//                        uid:"vc-upload-1589187988243621",
//                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
//                    }],
        caipan: [],
        jiaolian: [],
      },
      rules: {
        mingcheng: [{ required: true, message: "请输入队伍名称", trigger: "blur" }],
        ldname: [{ required: true, message: "请输入领队姓名", trigger: "blur" }],
        namekey: [{ required: true, message: "请选择省市", trigger: "blur" }],
        nickname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        ldnum: [
          { required: true, message: "证件号码不能为空", trigger: "blur" },
        ],
        jianhunum: [
          { required: true, message: "请输入正确的身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        huzhao: [
          { required: true, message: "证件号码不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        lxname: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        lxphone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        jianhuphone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入正确的邮箱", trigger: "blur" },
          { validator: validator.email, trigger: "blur" },
        ],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = '秩序册填写';
    that.fetch();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/isai/step1Detail', {
        saiqu_id: that.saiqu_id,
        id: that.formData.id,
      }, (res) => {
        // 存在问题
        if(!res.data.caipan) {
          that.formData = Object.assign(that.formData, res.data);
        } else {
          that.formData = res.data;
        }

        if (that.formData.danwei_status == 0) {
          that.$confirm('报名前请先进行单位信息的备案或者绑定','请先认证', {
            confirmButtonText: '进行单位认证或绑定',
            showClose: false,
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
          }).then(() => {
            rbLink({
              name: 'CertDanwei'
            })
          }).catch(() => {
          });
          // Dialog.alert({
          //   title: '请先认证',
          //   message: '报名前请先进行单位信息的备案或者绑定',
          //   confirmButtonText: '进行单位认证或绑定'
          // }).then(() => {
          //   // on close
          //   rbLink({
          //     name: 'CertDanwei'
          //   })
          // });
        } else if (that.formData.danwei_status == 1) {
          that.$confirm('您的单位信息正在审核请耐心等待审核通过','请等待认证审核', {
            confirmButtonText: '查看详情',
            showClose: false,
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
          }).then(() => {
            rbLink({
              name: 'CertDanweiResult'
            })
          }).catch(() => {
          });
          // Dialog.alert({
          //   title: '请等待认证审核',
          //   message: '您的单位信息正在审核请耐心等待审核通过',
          //   confirmButtonText: '查看详情'
          // }).then(() => {
          //   // on close
          //   rbLink({
          //     name: 'CertDanweiResult'
          //   })
          // });
        } else if (that.formData.danwei_status == 3) {
          that.$confirm('您的单位信息未通过审核','单位认证未通过', {
            confirmButtonText: '查看详情',
            showClose: false,
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
          }).then(() => {
            rbLink({
              name: 'CertDanweiResult'
            })
          }).catch(() => {
          });
          // Dialog.alert({
          //   title: '单位认证未通过',
          //   message: '您的单位信息未通过审核',
          //   confirmButtonText: '查看详情'
          // }).then(() => {
          //   // on close
          //   rbLink({
          //     name: 'CertDanweiResult'
          //   })
          // });
        } else if (that.formData.jiaolian_count == 0) {
          that.$confirm('请先注册教练员信息','没有注册教练员信息', {
            confirmButtonText: '立即注册',
            showClose: false,
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
          }).then(() => {
            rbLink({
              name: 'JiaolianList'
            })
          }).catch(() => {
          });
          // Dialog.alert({
          //   title: '没有注册教练员信息',
          //   message: '请先注册教练员信息',
          //   confirmButtonText: '立即注册'
          // }).then(() => {
          //   // on close
          //   rbLink({
          //     name: 'JiaolianList'
          //   })
          // });
        } else if (that.formData.un_complete > 0) {
          that.$confirm('建议您选择继续未完成的报名','您有未完成的报名', {
            confirmButtonText: '继续未完成的报名',
            cancelButtonText: '重新报名',
            showClose: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
          }).then(() => {
            that.jumToOld();
          }).catch(() => {
          });
          // Dialog.setDefaultOptions({
          //   'confirmButtonText': '继续未完成的报名',
          //   'cancelButtonText': '重新报名',
          // })
          // Dialog.confirm({
          //   title: '您有未完成的报名',
          //   message: '建议您选择继续未完成的报名'
          // }).then(() => {
          //   that.jumToOld();
          // }).catch(() => {
          // });
        }

      }, (res) => {
        console.log('没有登录');
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    onQuestion() {
      console.log('onQuestion')
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName])
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.formData.heying.length == 0) {
            this.$message.warning('请上传队伍照片');
            return
          }
          if (this.formData.jiaolian.length==0) {
            this.$message.warning('请至少选择一位教练');
            return
          }
          that.saveLoading = true;
          that.$api.post("/api/isai/baoming", that.formData, (res) => {
            that.saveLoading = false;

            appEvent({
              name: 'saiApplyDetailReload',
              query: {
              }
            });
            setTimeout(function () {
              rbLink({
                'name' : 'ISaiApplyDetail',
                'query':{
                  id:res.data.id
                }
              },'replace')
            },50);
          }, (res) => {
            if(res.code == 505){
              Dialog.alert({
                title: '等待认证',
                message: res.msg,
                confirmButtonText:'查看详情'
              }).then(() => {
                // on close
                rbLink({
                  name:'CertDanwei'
                })
              });
            }else{
              that.$message.error(res.msg)
            }
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onCaipanConfirm(values){
      console.log('onCaipanConfirm',values)
      this.showCaipanPicker = false;
      this.formData.caipan = [...values];
    },
    onCaipanChange(values){
      console.log('onCaipanChange',values)
      this.formData.caipan = [...values];
    },
    onJiaolianConfirm(values) {
      console.log('onJiaolianConfirm', values)
      this.showJiaolianPicker = false;
      this.formData.jiaolian = [...values];
    },
    onJiaolianChange(values) {
      console.log('onJiaolianChange', values)
      this.formData.jiaolian = [...values];
    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.ldcardtype = index + 1;
      this.showNumTypePicker = false;
    },
    jumToOld(id) {
      rbLink({
        name: 'ISaiApplyList'
      }, 'replace')
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

        if (that.formData.heying.length == 0) {
          Toast('请上传队伍照片');
          return
        }
        if (this.formData.jiaolian.length == 0) {
          Toast('请至少选择一位教练');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/isai/baoming', that.formData, (res) => {
        that.saveLoading = false;

        appEvent({
          name: 'saiApplyDetailReload',
          query: {}
        });
        setTimeout(function () {
          rbLink({
            'name': 'ISaiApplyDetail',
            'query': {
              id: res.data.id
            }
          }, 'replace')
        }, 50);
      }, (res) => {
        if (res.code == 505) {
          Dialog.alert({
            title: '等待认证',
            message: res.msg,
            confirmButtonText: '查看详情'
          }).then(() => {
            // on close
            rbLink({
              name: 'CertDanwei'
            })
          });
        } else {
          Toast.fail(res.msg);
        }
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep1.vue?2048c224